__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/16fded1d5028e65baf11a0c855c734f85a2234bc964a4310ca55d9a0/";